const de = {
  "common": {
    "save": "Speichern",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "add": "Hinzufügen",
    "search": "Suchen",
    "loading": "Laden...",
    "error": "Fehler",
    "success": "Erfolg",
    "confirm": "Bestätigen",
    "back": "Zurück",
    "next": "Weiter",
    "previous": "Vorherige",
    "close": "Schließen",
    "submit": "Absenden",
    "update": "Aktualisieren",
    "view": "Ansehen",
    "download": "Herunterladen",
    "upload": "Hochladen",
    "select": "Auswählen",
    "all": "Alle",
    "none": "Keine",
    "yes": "Ja",
    "no": "Nein"
  },
  "nav": {
    "dashboard": "Dashboard",
    "createAd": "Anzeige erstellen",
    "campaigns": "Kampagnen",
    "insights": "Einblicke",
    "contextiq": "ContextIQ",
    "adGallery": "Anzeigengalerie",
    "university": "Universität",
    "managedServices": "Managed Services",
    "resources": "Ressourcen",
    "settings": "Einstellungen",
    "signOut": "Abmelden",
    "help": "Hilfe & Ressourcen"
  },
  "header": {
    "searchPlaceholder": "Kampagnen, Kreative suchen...",
    "notifications": "Benachrichtigungen",
    "viewAllNotifications": "Alle Benachrichtigungen anzeigen",
    "accountSettings": "Kontoeinstellungen",
    "manageSubscription": "Abonnement verwalten",
    "upgradePlan": "Plan upgraden",
    "updateProfile": "Profil aktualisieren",
    "takeTour": "Tour machen",
    "language": "Sprache"
  },
  "dashboard": {
    "title": "Dashboard",
    "welcome": "Willkommen zurück",
    "overview": "Übersicht",
    "recentCampaigns": "Aktuelle Kampagnen",
    "topPerformingAds": "Top-Anzeigen",
    "quickActions": "Schnellaktionen",
    "createNewAd": "Neue Anzeige erstellen",
    "viewCampaigns": "Kampagnen anzeigen",
    "viewInsights": "Einblicke anzeigen",
    "impressions": "Impressionen",
    "clicks": "Klicks",
    "ctr": "CTR",
    "spend": "Ausgaben",
    "conversions": "Conversions",
    "revenue": "Umsatz",
    "performance": "Leistung",
    "thisMonth": "Dieser Monat",
    "lastMonth": "Letzter Monat",
    "contextiqWidget": {
      "title": "ContextIQ Einblicke",
      "brandMatches": "Markenübereinstimmungen",
      "alignmentScore": "Ausrichtungswert",
      "topOpportunities": "Top-Möglichkeiten",
      "viewAll": "Alle anzeigen"
    }
  },
  "campaigns": {
    "title": "Kampagnen",
    "subtitle": "Verwalten und überwachen Sie Ihre Werbekampagnen",
    "createCampaign": "Kampagne erstellen",
    "allCampaigns": "Alle Kampagnen",
    "active": "Aktiv",
    "paused": "Pausiert",
    "completed": "Abgeschlossen",
    "draft": "Entwurf",
    "scheduled": "Geplant",
    "status": "Status",
    "budget": "Budget",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "noCampaigns": "Noch keine Kampagnen",
    "createFirst": "Erstellen Sie Ihre erste Kampagne, um zu beginnen"
  },
  "insights": {
    "title": "Einblicke",
    "subtitle": "Analysieren Sie Ihre Kampagnenleistung",
    "campaigns": "Kampagnen",
    "creatives": "Kreative",
    "audience": "Zielgruppe",
    "dateRange": "Zeitraum",
    "export": "Exportieren",
    "metrics": {
      "totalImpressions": "Gesamtimpressionen",
      "totalClicks": "Gesamtklicks",
      "averageCtr": "Durchschnittliche CTR",
      "totalSpend": "Gesamtausgaben",
      "costPerClick": "Kosten pro Klick",
      "conversionRate": "Konversionsrate"
    }
  },
  "contextiq": {
    "title": "ContextIQ",
    "subtitle": "KI-gestütztes kontextuelles Targeting",
    "brandAnalysis": "Markenanalyse",
    "contentMatching": "Inhaltsabgleich",
    "opportunities": "Möglichkeiten",
    "safetyScore": "Markensicherheitswert",
    "alignmentScore": "Ausrichtungswert",
    "analyzeUrl": "URL analysieren",
    "enterUrl": "URL zur Analyse eingeben",
    "analyze": "Analysieren",
    "results": "Ergebnisse",
    "noResults": "Noch keine Ergebnisse",
    "startAnalyzing": "Geben Sie oben eine URL ein, um mit der Analyse zu beginnen"
  },
  "gallery": {
    "title": "Anzeigengalerie",
    "subtitle": "Durchsuchen und verwalten Sie Ihre kreativen Assets",
    "uploadNew": "Neu hochladen",
    "allCreatives": "Alle Kreativen",
    "images": "Bilder",
    "videos": "Videos",
    "html5": "HTML5",
    "templates": "Vorlagen",
    "sortBy": "Sortieren nach",
    "newest": "Neueste",
    "oldest": "Älteste",
    "name": "Name",
    "noCreatives": "Noch keine Kreativen",
    "uploadFirst": "Laden Sie Ihr erstes Kreativ hoch, um zu beginnen"
  },
  "university": {
    "title": "Adventive Universität",
    "subtitle": "Meistern Sie interaktive Werbung",
    "courses": "Kurse",
    "certifications": "Zertifizierungen",
    "resources": "Ressourcen",
    "progress": "Ihr Fortschritt",
    "completedCourses": "Abgeschlossene Kurse",
    "inProgress": "In Bearbeitung",
    "startLearning": "Lernen beginnen",
    "continueLearning": "Weiter lernen",
    "viewCourse": "Kurs ansehen",
    "certificate": "Zertifikat"
  },
  "managedServices": {
    "title": "Managed Services",
    "subtitle": "Lassen Sie unsere Experten Ihre Anzeigen erstellen",
    "newRequest": "Neue Anfrage",
    "activeRequests": "Aktive Anfragen",
    "completedRequests": "Abgeschlossene Anfragen",
    "requestStatus": {
      "pending": "Ausstehend",
      "inProgress": "In Bearbeitung",
      "review": "In Prüfung",
      "completed": "Abgeschlossen",
      "needsInput": "Eingabe erforderlich"
    },
    "submitRequest": "Anfrage absenden",
    "requestDetails": "Anfragedetails"
  },
  "settings": {
    "title": "Einstellungen",
    "subtitle": "Verwalten Sie Ihre Kontoeinstellungen",
    "profile": "Profil",
    "organization": "Organisation",
    "team": "Team",
    "notifications": "Benachrichtigungen",
    "security": "Sicherheit",
    "billing": "Abrechnung",
    "preferences": "Einstellungen",
    "language": "Sprache",
    "timezone": "Zeitzone",
    "theme": "Design",
    "darkMode": "Dunkelmodus",
    "lightMode": "Hellmodus",
    "systemDefault": "Systemstandard",
    "restartTour": "Plattform-Tour neu starten",
    "restartTourDesc": "Machen Sie eine geführte Tour durch die Plattformfunktionen",
    "profileInfo": {
      "title": "Profilinformationen",
      "subtitle": "Aktualisieren Sie Ihre persönlichen Daten und Einstellungen",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail-Adresse",
      "phone": "Telefonnummer",
      "changePhoto": "Foto ändern",
      "photoHint": "JPG, PNG oder GIF. Max 2MB."
    },
    "organizationInfo": {
      "title": "Organisationsdetails",
      "subtitle": "Verwalten Sie Ihre Organisationsinformationen",
      "name": "Organisationsname",
      "type": "Organisationstyp",
      "industry": "Branche",
      "website": "Website",
      "address": "Adresse"
    },
    "teamMembers": {
      "title": "Teammitglieder",
      "subtitle": "Verwalten Sie Ihr Team",
      "inviteMember": "Mitglied einladen",
      "role": "Rolle",
      "admin": "Administrator",
      "editor": "Bearbeiter",
      "viewer": "Betrachter",
      "pending": "Ausstehend"
    },
    "notificationPrefs": {
      "title": "Benachrichtigungseinstellungen",
      "subtitle": "Wählen Sie, wie Sie benachrichtigt werden möchten",
      "campaignUpdates": "Kampagnen-Updates",
      "campaignUpdatesDesc": "Benachrichtigung bei Kampagnenstart, -pause oder -abschluss",
      "performanceReports": "Leistungsberichte",
      "performanceReportsDesc": "Tägliche oder wöchentliche Leistungszusammenfassungen erhalten",
      "creativeApprovals": "Kreativ-Genehmigungen",
      "creativeApprovalsDesc": "Benachrichtigung bei Genehmigung oder Überarbeitungsbedarf von Kreativen",
      "usageAlerts": "Nutzungswarnungen",
      "usageAlertsDesc": "Benachrichtigung bei Annäherung oder Überschreitung von Impressionslimits",
      "pushNotifications": "Push-Benachrichtigungen",
      "pushNotificationsDesc": "Echtzeit-Browser-Benachrichtigungen erhalten",
      "weeklyDigest": "Wöchentliche Zusammenfassung",
      "weeklyDigestDesc": "Wöchentliche Zusammenfassung Ihrer Kontoaktivität erhalten"
    },
    "securitySettings": {
      "title": "Sicherheitseinstellungen",
      "subtitle": "Verwalten Sie Ihre Kontosicherheit",
      "changePassword": "Passwort ändern",
      "changePasswordDesc": "Aktualisieren Sie Ihr Passwort regelmäßig für mehr Sicherheit",
      "twoFactor": "Zwei-Faktor-Authentifizierung",
      "twoFactorDesc": "Fügen Sie Ihrem Konto eine zusätzliche Sicherheitsebene hinzu",
      "notEnabled": "Nicht aktiviert",
      "enabled": "Aktiviert",
      "activeSessions": "Aktive Sitzungen",
      "currentSession": "Aktuelle Sitzung",
      "activeNow": "Jetzt aktiv"
    },
    "billingSettings": {
      "title": "Abrechnung",
      "overview": "Übersicht",
      "usage": "Nutzung",
      "invoices": "Rechnungen",
      "payments": "Zahlungen",
      "planHistory": "Plan-Historie",
      "currentPlan": "Aktueller Plan",
      "changePlan": "Plan ändern",
      "paymentMethod": "Zahlungsmethode",
      "billingInfo": "Rechnungsinformationen",
      "updatePayment": "Zahlungsmethode aktualisieren",
      "impressionsUsed": "Verwendete Impressionen",
      "cpmRate": "CPM-Rate",
      "overage": "Überschreitung",
      "overageCost": "Überschreitungskosten"
    },
    "saveChanges": "Änderungen speichern",
    "changesSaved": "Änderungen erfolgreich gespeichert"
  },
  "tour": {
    "welcome": {
      "title": "Willkommen bei Adventive!",
      "description": "Machen wir eine kurze Tour, um Ihnen den Einstieg in die Plattform zu erleichtern. Sie lernen, wie Sie Anzeigen erstellen, Kampagnen verwalten und auf leistungsstarke Einblicke zugreifen."
    },
    "dashboard": {
      "title": "Ihr Dashboard",
      "description": "Dies ist Ihre Kommandozentrale. Sehen Sie wichtige Kennzahlen, aktuelle Kampagnen und Schnellaktionen an einem Ort. Das Dashboard gibt Ihnen einen Echtzeit-Überblick über Ihre Werbeleistung."
    },
    "createAd": {
      "title": "Erstellen Sie Ihre erste Anzeige",
      "description": "Klicken Sie hier, um mit dem Erstellen interaktiver, ansprechender Anzeigen zu beginnen. Unser Drag-and-Drop-Builder macht es einfach, Rich-Media-Anzeigen ohne Programmierung zu erstellen.",
      "action": "Beginnen Sie mit der Erstellung Ihrer ersten Anzeige"
    },
    "campaigns": {
      "title": "Kampagnen verwalten",
      "description": "Organisieren und verfolgen Sie alle Ihre Werbekampagnen. Legen Sie Budgets, Zeitpläne und Targeting-Optionen fest. Überwachen Sie die Leistung in Echtzeit."
    },
    "insights": {
      "title": "Leistungsstarke Einblicke",
      "description": "Tauchen Sie tief in Ihre Kampagnenleistung ein. Analysieren Sie Impressionen, Klicks, Engagement-Raten und Zielgruppenverhalten mit detaillierten Analysen."
    },
    "contextiq": {
      "title": "ContextIQ Intelligenz",
      "description": "Unser KI-gestütztes kontextuelles Targeting hilft Ihnen, die richtige Zielgruppe im richtigen Moment zu erreichen. Analysieren Sie Inhalte, finden Sie Markenausrichtungen und entdecken Sie Möglichkeiten."
    },
    "gallery": {
      "title": "Anzeigengalerie",
      "description": "Greifen Sie auf alle Ihre Kreativen an einem Ort zu. Vorschau, Duplizieren, Bearbeiten oder Archivieren Sie Ihre Anzeigen. Halten Sie Ihre kreative Bibliothek organisiert und zugänglich."
    },
    "managedServices": {
      "title": "Managed Services",
      "description": "Brauchen Sie Hilfe? Unser Expertenteam kann maßgeschneiderte Anzeigen für Sie erstellen. Senden Sie eine Anfrage und wir kümmern uns um die kreative Arbeit, während Sie sich auf die Strategie konzentrieren."
    },
    "university": {
      "title": "Adventive Universität",
      "description": "Verbessern Sie Ihre Fähigkeiten mit unseren Lernressourcen. Greifen Sie auf Tutorials, Best Practices und Zertifizierungskurse zu, um ein Experte für interaktive Werbung zu werden."
    },
    "complete": {
      "title": "Sie sind bereit!",
      "description": "Sie sind bereit, erstaunliche interaktive Anzeigen zu erstellen. Wenn Sie jederzeit Hilfe benötigen, schauen Sie in unseren Ressourcenbereich oder kontaktieren Sie den Support."
    },
    "skipTour": "Tour überspringen",
    "getStarted": "Loslegen"
  },
  "plan": {
    "base": "Basis",
    "professional": "Professional",
    "enterprise": "Enterprise",
    "upgrade": "Upgraden",
    "current": "Aktueller Plan",
    "perMonth": "/Monat"
  },
  "brands": {
    "currentView": "Aktuelle Ansicht",
    "allBrands": "Alle Marken",
    "selectBrand": "Marke auswählen",
    "addBrand": "Marke hinzufügen",
    "noBrands": "Noch keine Marken hinzugefügt",
    "addBrandsHint": "Fügen Sie Marken hinzu, um mehrere Kunden zu verwalten"
  },
  "errors": {
    "somethingWentWrong": "Etwas ist schief gelaufen",
    "tryAgain": "Bitte versuchen Sie es erneut",
    "notFound": "Seite nicht gefunden",
    "unauthorized": "Unbefugter Zugriff",
    "networkError": "Netzwerkfehler"
  },
  "time": {
    "justNow": "Gerade eben",
    "minutesAgo": "vor {{count}} Min.",
    "hoursAgo": "vor {{count}} Stunde",
    "hoursAgo_plural": "vor {{count}} Stunden",
    "daysAgo": "vor {{count}} Tag",
    "daysAgo_plural": "vor {{count}} Tagen"
  }
};

export default de;
